import isString from 'lodash.isstring';

const isFilledString = str => isString(str) && str.length > 0;
const getNumbersOnlyString = v => v.replace(/[^0-9]/g, '');
const getNumberString = function (v) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    addComma: false,
    maxDecimalDigits: 0
  };
  const {
    addComma = false,
    maxDecimalDigits = 0
  } = options;
  const dotIndex = v.indexOf('.');
  if (maxDecimalDigits === 0 || dotIndex === -1) {
    const integerPart = getNumbersOnlyString(v);
    return addComma && integerPart ? BigInt(integerPart).toLocaleString('ko-KR') : integerPart;
  }
  const integerPart = getNumbersOnlyString(v.slice(0, dotIndex)) || '0';
  const decimalPart = getNumbersOnlyString(v.slice(dotIndex + 1)).slice(0, maxDecimalDigits);
  return `${addComma ? BigInt(integerPart).toLocaleString('ko-KR') : integerPart}.${decimalPart}`;
};
// 랜덤 문자열을 생성한다.
function getRandomString() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return `${prefix}${(Math.random() + 1).toString(36).substring(2)}`;
}

export { getNumberString, getNumbersOnlyString, getRandomString, isFilledString };
